/** @format */
import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Table,
  Radio,
  Modal,
  Input,
  Select,
  DatePicker,
  Tag,
  Row,
  Col,
  message,
} from "antd";
import moment from "moment";
import Cookies from "universal-cookie";

const cookies = new Cookies();
const { Option } = Select;

const currentToken = cookies.get("access_token");

const HIVE_TYPES = [
 "Type A", "Type C", "Hanging"
];

const BeehiveBatches = () => {
  const [batches, setBatches] = useState([]);
  const [factories, setFactories] = useState([]);
  const [loading, setLoading] = useState(false);
  const BASE_URL = process.env.REACT_APP_API_APP_FIELD_URL;

  const [modalOpen, setModalOpen] = useState(false);
  const [form, setForm] = useState({
    factory_id: "",
    supply_date: null,
    total_hives: "",
    hive_type: "",
    owner_type: "HB",
    remarks: "",
  });

  /* ---------------- Fetch Factories ---------------- */

  const fetchFactories = async () => {
  try {
    const res = await axios.get(`${BASE_URL}/nector/web/factories`, {
      headers: {
        'Content-Type': 'application/json',
        source: 'humblebee_admin',
        authorization: `Bearer ${currentToken}`,
      },
    });

    console.log("FACTORIES API RAW RESPONSE:", res.data);

    setFactories(res.data || []);
  } catch (err) {
    console.error("Factory fetch error:", err);
    message.error("Failed to load factories");
  }
};

  /* ---------------- Fetch Batches ---------------- */

  const fetchBatches = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${BASE_URL}/nector/web/hive-batches`, {
        headers: {
          'Content-Type': 'application/json',
          source: 'humblebee_admin',
          authorization: `Bearer ${currentToken}`,
        },
      });
      setBatches(res.data || []);
    } catch {
      message.error("Failed to load batches");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFactories();
    fetchBatches();
  }, []);

  /* ---------------- Create ---------------- */

  const openAdd = () => {
    setForm({
      factory_id: "",
      supply_date: null,
      total_hives: "",
      hive_type: "",
      owner_type: "HB",
      remarks: "",
    });
    setModalOpen(true);
  };

  const submit = async () => {
    if (
      !form.factory_id ||
      !form.supply_date ||
      !form.total_hives ||
      !form.hive_type
    ) {
      return message.warning("Fill all required fields");
    }

    try {
      await axios.post(
        `${BASE_URL}/nector/web/hive-batches`,
        {
          ...form,
          supply_date: form.supply_date.format("YYYY-MM-DD"),
        },
        {
          headers: {
            'Content-Type': 'application/json',
            source: 'humblebee_admin',
            authorization: `Bearer ${currentToken}`,
          },
        }
      );

      message.success("Batch created");
      setModalOpen(false);
      fetchBatches();
    } catch (err) {
      message.error(err?.response?.data?.error || "Create failed");
    }
  };

  /* ---------------- Table ---------------- */

  const columns = [
    { title: "Factory ID", dataIndex: "factory_id" },
    { title: "Batch ID", dataIndex: "batch_id" },
    {
      title: "Supply Date",
      dataIndex: "supply_date",
      render: v => moment(v).format("DD MMM YYYY"),
    },
    { title: "Total Hives", dataIndex: "total_hives" },
    { title: "Hive Type", dataIndex: "hive_type" },
    {
      title: "Owner",
      dataIndex: "owner_type",
      render: v => (v === "HB" ? "Humble Bee" : "Community"),
    },
    {
      title: "Status",
      render: () => <Tag>In Storage</Tag>,
    },
  ];

  /* ---------------- UI ---------------- */

  return (
    <div style={{ padding: 24,marginLeft: 250 }}>
      <div>
        <h2>Total Beehive Batches</h2>
        <button className="btn add-new-scheme-btn" onClick={openAdd}>
          Add New Batch
        </button>
      </div>

      <Table
        style={{ marginTop: 16 }}
        rowKey="batch_id"
        columns={columns}
        dataSource={batches}
        loading={loading}
      />

      {/* ---------------- Modal ---------------- */}

      <Modal
        title="Add Batch"
        visible={modalOpen}
        onCancel={() => setModalOpen(false)}
        onOk={submit}
        okText="Submit"
        okButtonProps={{
          className:"btn add-new-scheme-btn"
        }}
      >
        <Row >
          <Col span={12}>
            <label>Factory *</label>
            <Select
              style={{ width: "100%" }}
              value={form.factory_id}
              onChange={(v) => setForm({ ...form, factory_id: v })}
              placeholder="Select Factory"
            >
              {factories
                .filter(f => f.is_active === true) // IMPORTANT
                .map(f => (
                  <Option key={f.factory_id} value={f.factory_id}>
                    {f.factory_id} — {f.name}
                  </Option>
                ))}
            </Select>
          </Col>

          <Col span={12}>
            <label>Supply Date *</label>
            <DatePicker
              style={{ width: "100%" }}
              value={form.supply_date}
              onChange={d => setForm({ ...form, supply_date: d })}
            />
          </Col>

          <Col span={12}>
            <label>Total Hives *</label>
            <Input
              type="number"
              value={form.total_hives}
              onChange={e =>
                setForm({ ...form, total_hives: Number(e.target.value) })
              }
            />
          </Col>

          <Col span={12} >
            <label>Hive Type *</label>
            <Select
              style={{ width: "100%" }}
              value={form.hive_type}
              onChange={v => setForm({ ...form, hive_type: v })}
            >
              {HIVE_TYPES.map(t => (
                <Option key={t}>{t}</Option>
              ))}
            </Select>
          </Col>

          <Col span={24} style={{ marginTop: 12 }}>
            <label>Owner *</label>
          <Radio.Group
            value={form.owner_type}
            onChange={e =>
              setForm({ ...form, owner_type: e.target.value })
            }
            
          >
            <Radio value="HB" >Humble Bee</Radio>
            <Radio value="Community">Community</Radio>
          </Radio.Group>

          </Col>

          <Col span={24} style={{ marginTop: 12 }}>
            <label>Remarks</label>
            <Input.TextArea
              rows={3}
              value={form.remarks}
              onChange={e =>
                setForm({ ...form, remarks: e.target.value })
              }
            />
          </Col>
        </Row>
      </Modal>
    </div>
  );
};

export default BeehiveBatches;
